<template>
  <div>
    <v-container grid-list-xl>
    <h2>RESET PASSWORD</h2>
      <v-form v-mode="valid" ref="form" lazy-validation>
        <v-flex xs8>
          <v-layout wrap>
            <v-flex xs12>
              <v-text-field
                label="Email-Address"
                v-model="email"
                :rules="emaiRules"
                required
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex xs12>
              <v-text-field
                label="Password"
                v-model="password"
                type="password"
                :rules="passwordRules"
                required
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex xs12>
              <v-text-field
                label="Confirm-password"
                v-model="password_confirmation"
                type="password"
                :rules="passwordRules"
                required
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex xs12 text-xs-right>
              <v-btn
                @click="onClickSubmitReset"
                color="primary"
                :disabled="!valid"
              >Submit</v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-form>
    </v-container>
  </div> 
</template>

<script>
  import config from '../../../../configApi'
  import {setAuthToken} from '@/utils/token'
  import axios from 'axios'
  const API_URL = config.apiUrl
  export default {
    data () {
      return {
        token: this.$route.params.token,
        email: '',
        password: '',
        password_confirmation: '',
        valid: true,
        emaiRules: [
          (v) => !!v || 'E-mail is required',
          (v) => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
        ],
        passwordRules: [
          (v) => !!v || 'Required',
          (v) => v.length >= 6 || 'Password must be greater than 5 characters',
          (v) => this.password_confirmation === this.password || 'Password did not match'
        ]
      }
    },
    methods: {
      onClickSubmitReset () {
        if (this.$refs.form.validate()) {
          this.sendResetPassword()
        }
      },
      sendResetPassword () {
        let data = {
          token: this.token,
          email: this.email,
          password: this.password,
          password_confirmation: this.password_confirmation
        }
        this.valid = false
        axios.post(`${API_URL}/password/reset`, data).then((response) => {
          let token = response.data.data
          if (token) {
            setAuthToken(token)
            this.setSessionUser()
          }
        }).catch((error) => {
          console.log(error)
        })
      },
      setSessionUser () {
        axios.get(`${API_URL}/user`).then((res) => {
          localStorage.setItem('user', JSON.stringify(res.data))
          sessionStorage.setItem('user', JSON.stringify(res.data))
          this.$router.push('/dashboard')
        }).catch((error) => {
          console.log(error)
        })
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/passwords/reset/index.vue